import client from '../client';
import * as underwritersQueries from "../queries/underwriter";
import * as underwritersMutations from "../mutations/underwriter";

export function getUnderwriters(success, error, force = false) {
    let fetchPolicy = 'cache-first';

    if (force === true) {
        fetchPolicy = 'network-only';
    }

    client.query({
        fetchPolicy: fetchPolicy,
        query: underwritersQueries.all,
    })
    .then(success)
    .catch(error);
}


export function add(success, error, data) {
    client.mutate({
        variables: { underwriter: data },
        mutation: underwritersMutations.add,
    }).then(success).catch(error);
}


export function edit(success, error, id, data) {
    client.mutate({
        variables: { id: id, underwriter: data },
        mutation: underwritersMutations.edit,
    })
    .then(success)
    .catch(error);
}


// WEBPACK FOOTER //
// ./src/graphql/actions/underwriter.js